import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import { brand } from '../../../content/site';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import HeroFerrofluid from '../HeroFerrofluid';

export default function HeroSection({ theme }) {
  const locale = useLocale();
  const copy = useMessages().home.hero;
  return (
    <section className="hero">
      <HeroFerrofluid theme={theme} />
      <div className="container hero-layout">
        <div className="hero-copy">
          <h1>
            {copy.title[0]}
            <br />
            <span className="hero-accent">{copy.title[1]}</span>
          </h1>
          <p>{copy.description}</p>
          <div className="hero-actions">
            <Link className="button button--primary" to={`${localizedPath(locale)}#products`}>
              {copy.products} <Arrow up />
            </Link>
            <Link className="button button--ghost" to={localizedPath(locale, '/company')}>
              {copy.about} {brand.name} <Arrow />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
